// import { whatIsNewImg } from '@/shared/ui/assets/png';
import { PDFViewer, CustomButton } from '@/shared/ui/components';
import _ from 'lodash';
import Skeleton from 'react-loading-skeleton';
import { t } from 'ttag';
import type { WhatIsNewModalProps } from './whatIsNewModal.types';
import './whatIsNewModal.scss';
import { useWhatIsNewModal } from './useWhatIsNewModal';

const WhatIsNewModal = ({
  willShowWhatNewPopup,
  displayWhatNewPopup,
  zIndex,
}: WhatIsNewModalProps) => {
  const { state, IDVIDEO, URL_PDF, onClickViewLater, onClickClose } = useWhatIsNewModal({
    willShowWhatNewPopup,
    displayWhatNewPopup,
  });

  return (
    <div className="whats-new-backdrop" style={{ zIndex }}>
      <div className="whats-new-modal">
        <div className="header-container">
          <span className="header">{t`What's new`}</span>
        </div>
        <div className="body-container">
          {/* <img
            className="whats-new-img"
            src={whatIsNewImg}
            alt="What's new"
          /> */}
          {_.isEmpty(state.dataWhatNew) ? (
            <div className="skeleton-container">
              <Skeleton height="100%" />
            </div>
          ) : state.dataWhatNew?.type === 'video' ? (
            <iframe
              id="whats-new-viewer-iframe"
              className="whats-new-video"
              title={t`What's New`}
              src={`https://www.youtube-nocookie.com/embed/${IDVIDEO.current}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : state.dataWhatNew?.type === 'pdf' ? (
            <PDFViewer url={URL_PDF.current} />
          ) : (
            <div />
          )}
        </div>
        <div className="footer-container">
          <CustomButton
            id="view-later-btn"
            type="outline"
            style="neutral"
            onClick={onClickViewLater}
          >
            {t`View later`}
          </CustomButton>
          <CustomButton id="got-it-btn" type="outline" style="default" onClick={onClickClose}>
            {t`Got it`}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default WhatIsNewModal;
